import { AlertCircleIcon } from "lucide-react";
import { Text } from "@/components/ui/text";

interface CheckoutErrorProps {
  title?: string;
  message?: string;
}

export function CheckoutError({
  title = "Session Not Found",
  message = "This payment link is invalid or has expired. Please contact the merchant for a new payment link.",
}: CheckoutErrorProps) {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="flex max-w-md flex-col items-center text-center">
        <div className="mb-6 flex size-20 items-center justify-center rounded-full bg-muted">
          <AlertCircleIcon className="size-10 text-muted-foreground" />
        </div>

        <Text variant="h2" className="mb-2">
          {title}
        </Text>

        <Text variant="muted">{message}</Text>
      </div>
    </div>
  );
}
